import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Main from "./main";
import { AuthContextProvider } from "./context/authContext";
import ReactGA from "react-ga";
const TRACKING_ID = "G-V0T2KD6F9C";
ReactGA.initialize(TRACKING_ID);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <AuthContextProvider>
    <Main />
  </AuthContextProvider>,
);
